
import { Options, prop, Vue } from "vue-class-component";
import OverlayPanel from "primevue/overlaypanel";
import Skeleton from "@/app/ui/components/skeleton/index.vue";
import formatByCountry from "@/app/infrastructures/misc/common-library/FormatByCountry";

class Props {
  totalPod = prop<number>({
    default: 0
  });
  totalRts = prop<number>({
    default: 0
  });
  totalHal = prop<number>({
    default: 0
  });
  isLoading = prop<boolean>({
    default: false
  });
}

@Options({
  components: {
    OverlayPanel,
    Skeleton
  }
})
export default class HeaderSTTShouldDel extends Vue.with(Props) {
  get totalPodString() {
    return formatByCountry(this.totalPod, { type: "quantity" });
  }

  get totalRtsString() {
    return formatByCountry(this.totalRts, { type: "quantity" });
  }

  get totalHalString() {
    return formatByCountry(this.totalHal, { type: "quantity" });
  }

  onClickCard(stt: string) {
    this.$router.push(`/urgent-delivery-management/urgent-${stt}`);
  }
}
